// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";

var appShellNarrowMaxPx = 1479;

var gamesListWidthKey = "gdc.gamesListWidth";

var gameHubPanelHiddenKey = "gdc.gameHubPanelHidden";

var railWidthVar = "--gdc-main-nav-rail-width";

var railExpandedStorageKey = "gdc.mainNavRailExpanded";

var railWidthStorageKey = "gdc.mainNavRailWidth";

var railSnapThreshold = 136;

function isNarrowViewport() {
  return matchMedia("(max-width: " + String(appShellNarrowMaxPx) + "px)").matches;
}

function isGameHubPath(pathname) {
  if (pathname === "/games") {
    return true;
  } else {
    return pathname.startsWith("/games/");
  }
}

function gameHubPanelHiddenFromStorage() {
  var match = sessionStorage.getItem(gameHubPanelHiddenKey);
  if ((match == null) || match !== "1") {
    return false;
  } else {
    return true;
  }
}

function readGamesListSavedWidth() {
  var raw = sessionStorage.getItem(gamesListWidthKey);
  if (raw == null) {
    return 320;
  }
  var n = Belt_Int.fromString(raw);
  if (n !== undefined && n >= 220 && n <= 600) {
    return n;
  } else {
    return 320;
  }
}

function readSavedRailWidth() {
  var match = sessionStorage.getItem(railExpandedStorageKey);
  if (!(match == null) && match === "1") {
    return 220;
  }
  var raw = sessionStorage.getItem(railWidthStorageKey);
  if (raw == null) {
    return 52;
  }
  var n = Belt_Int.fromString(raw);
  if (n !== undefined && !Number.isNaN(n) && n >= railSnapThreshold) {
    return 220;
  } else {
    return 52;
  }
}

function readMainNavRailWidthPx() {
  var raw = getComputedStyle(document.documentElement).getPropertyValue(railWidthVar).trim();
  var n = Belt_Int.fromString(raw);
  if (n !== undefined && n > 0) {
    return n;
  } else {
    return readSavedRailWidth();
  }
}

function getMainNavRailWidth() {
  return readMainNavRailWidthPx();
}

function lhspPanelPadPx(state) {
  if (state.gameHubPanelHidden) {
    return 0;
  }
  if (state.gameHubPath && state.gameHubHiddenFromStorage) {
    return 0;
  }
  if (state.collapsed) {
    return 48;
  }
  var width = state.inlineWidth;
  if (width !== undefined && width > 0) {
    return width;
  } else {
    return state.savedWidth;
  }
}

function computeSidebarPad(navWidth, lhspWidth, isNarrow) {
  if (isNarrow) {
    return {
            lhsp: 0,
            pad: 0
          };
  } else {
    return {
            lhsp: lhspWidth,
            pad: navWidth + lhspWidth | 0
          };
  }
}

function parseInlineWidth(raw) {
  var n = Belt_Int.fromString(raw);
  if (n !== undefined && n > 0) {
    return n;
  }
  
}

function syncAppSidebarPad() {
  if (isNarrowViewport()) {
    var rootStyle = document.documentElement.style;
    rootStyle.setProperty("--gdc-lhsp-panel-width", "0px");
    rootStyle.setProperty("--gdc-sidebar-pad", "0px");
    return ;
  }
  var panel = document.getElementById("games-list-panel");
  var nav = readMainNavRailWidthPx();
  var lhsp = !(panel == null) ? lhspPanelPadPx({
          gameHubPanelHidden: DomEl$GameDataCore.hasClass(panel, "game-hub-panel-hidden"),
          gameHubPath: isGameHubPath(window.location.pathname),
          gameHubHiddenFromStorage: gameHubPanelHiddenFromStorage(),
          collapsed: DomEl$GameDataCore.hasClass(panel, "collapsed"),
          inlineWidth: parseInlineWidth(panel.style.width),
          savedWidth: readGamesListSavedWidth()
        }) : 0;
  var pad = computeSidebarPad(nav, lhsp, false);
  var rootStyle$1 = document.documentElement.style;
  rootStyle$1.setProperty("--gdc-lhsp-panel-width", String(pad.lhsp) + "px");
  rootStyle$1.setProperty("--gdc-sidebar-pad", String(pad.pad) + "px");
}

var appShellMdMinPx = 1480;

var gamesListCollapsedPadWidth = 48;

var gamesListDefaultWidth = 320;

var gamesListMinWidth = 220;

var gamesListMaxWidth = 600;

var railCollapsedWidth = 52;

var railExpandedWidth = 220;

export {
  appShellMdMinPx ,
  appShellNarrowMaxPx ,
  gamesListCollapsedPadWidth ,
  gamesListDefaultWidth ,
  gamesListMinWidth ,
  gamesListMaxWidth ,
  gamesListWidthKey ,
  gameHubPanelHiddenKey ,
  railWidthVar ,
  railExpandedStorageKey ,
  railWidthStorageKey ,
  railCollapsedWidth ,
  railExpandedWidth ,
  railSnapThreshold ,
  isNarrowViewport ,
  isGameHubPath ,
  gameHubPanelHiddenFromStorage ,
  readGamesListSavedWidth ,
  readSavedRailWidth ,
  readMainNavRailWidthPx ,
  getMainNavRailWidth ,
  lhspPanelPadPx ,
  computeSidebarPad ,
  parseInlineWidth ,
  syncAppSidebarPad ,
}
/* No side effect */
